const layoutConstants = Object.freeze({
  drawerWidth: 259,
  miniDrawerWidth: 60,
  drawerOpen: false,
  componentDrawerOpen: false,
});

export default layoutConstants;
